/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { ChangeDetectorRef, Directive, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BaseMessageComponent } from './base-message.component';

@Directive()
export abstract class BaseNgFormAdminComponent extends BaseMessageComponent {
  @ViewChild('f') adminForm: NgForm;

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }

  protected getChangedIndex(f: NgForm): number[] {
    const changedIndexes: number[] = [];
    Object.keys(f.controls).forEach((name) => {
      const currentControl = f.controls[name];
      if (currentControl.dirty) {
        const UIindex = +name.substr(name.indexOf('__') + 2);
        changedIndexes.push(UIindex);
      }
    });
    return changedIndexes;
  }

  resetChanges(): void {
    if (this.adminForm) {
      this.adminForm.resetForm();
    }
    this.reloadData();
  }

  protected abstract reloadData(): void;
}
